module.exports = __webpack_public_path__ + "static/media/icon6.689fcef8.svg";